import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { getPathFromPlaceAndType } from 'utils/paths';
import { places, excludes as excludesPath } from '../../constants/api';
import { PATH } from '../../envs/core';

import RESTDataCache from '../api/cacheData';

import { PROPERTIES_JSON } from '../../core/constants';

export const sites = {
  'www.antena3.com': 41,
  'www.lasexta.com': 7,
  'www.ondacero.es': 2
};
window.placesSearch = {};

export const getPlace = ({ filter = '', type, electionType = 'REGIONAL' }) => {
  if (window.placesSearch[`${filter}_${type}_${electionType}`]) {
    return Promise.resolve(
      window.placesSearch[`${filter}_${type}_${electionType}`]
    );
  }
  return Axios.get(`${PATH}${places}${filter.replace('&grandpaid=C108', '')}`).then(async response => {
    const props = await RESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
    const content = response.data.content.map((item, index) => ({
      ...item,
      path: getPathFromPlaceAndType(item, electionType, props)
    }));

    const sitesWithPath = {
      ...response.data,
      content
    };
    window.placesSearch[`${filter}_${type}_${electionType}`] = sitesWithPath;
    return sitesWithPath;
  });
};

export const getChilds = (typeplace, parentId, type) =>
  getPlace({
    filter: `typeplace=${typeplace}&parentid=${parentId}&size=1000`,
    type,
    electionType: type
  });

export const getManualPages = (type, numElection, year, communityId) => {
  const site = sites[window.location.hostname] || 41;

  return Axios.get(
    `${PATH}${excludesPath}${site}/${type}/${numElection}/${year}?regionId=${communityId}`
  ).then(
    response =>
      // TODO aqui ira la logica de la navegacion

      response.data
  );
};
export const empty = [];

export const PlacesProvider = ({
  type,
  parentId,
  name,
  children,
  grandParentId,
  size,
  search,
  sortby,
  excludedGrandParentIds,
  includedIds,
  electionType
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const parentQuery = parentId ? `&parentid=${parentId}` : '';
    const grandParentQuery = grandParentId ? `&grandpaid=${grandParentId}` : '';
    const nameQuery = name ? `&name=${name}` : '';
    const searchQuery = search ? `&search=${search}` : '';
    const sizeQuery = `&size=${size || 1000}`;
    const sortbyQuery = sortby ? `&sortby=${sortby}` : '';
    const typeQuery = type ? `typeplace=${type}` : '';
    const excludedQuery = excludedGrandParentIds.reduce(
      (result, id) => `${result}&excludeid=${id}`,
      ''
    );
    const includedQuery = includedIds.reduce(
      (result, id) => `${result}&addid=${id}`,
      ''
    );

    const filter = `${typeQuery}${grandParentQuery}${parentQuery}${nameQuery}${sizeQuery}${searchQuery}&page=0${sortbyQuery}${excludedQuery}${includedQuery}`;

    getPlace({ filter, type, electionType }).then(response => {
      setData(response.content);
    });
  }, [
    type,
    parentId,
    name,
    includedIds,
    grandParentId,
    search,
    sortby,
    excludedGrandParentIds,
    size
  ]);

  return children(data || empty);
};

PlacesProvider.propTypes = {
  type: PropTypes.string.isRequired,
  parentId: PropTypes.string,
  name: PropTypes.string,
  children: PropTypes.func.isRequired,
  size: PropTypes.number,
  excludedGrandParentIds: PropTypes.array,
  includedIds: PropTypes.array
};

PlacesProvider.defaultProps = {
  parentId: '',
  name: '',
  size: 1000,
  excludedGrandParentIds: [],
  includedIds: []
};
